window.Raphael = require('raphael');
